/**
 * Chronos Watch Shop - Main Application Entry Point
 * 
 * This file bootstraps the React application and wraps it with
 * an ErrorBoundary to gracefully handle runtime errors.
 */

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Create and render the application root
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
